import { Paper } from '@mui/material';
import { ReactNode } from 'react';
import { defaultPadding } from 'src/pages/MuiSandboxPage/cssGlobalProps';

/**
 * example component to demonstrate the usage of a reusable component
 */
export function SandboxPaper(props: {children: ReactNode}) {
  return (
      <Paper elevation={3} sx={{padding: defaultPadding}}>
        {props.children}
      </Paper>
  )
}